"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserMenu = void 0;
var core_1 = require("@material-ui/core");
var styles_1 = require("@material-ui/core/styles");
var clsx_1 = __importDefault(require("clsx"));
var react_1 = __importStar(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var Drawer_1 = require("../Drawer");
var useStyles = styles_1.makeStyles(function (theme) {
    return styles_1.createStyles({
        root: {},
        avatarRoot: {
            cursor: 'pointer',
            height: "2.5rem",
            width: "2.5rem",
        },
        header: {
            '&:active, &:focus': {
                outline: 'none',
            },
        },
        headerRoot: {
            minHeight: '4rem',
        },
        menuTitle: {
            fontSize: '1rem',
            lineHeight: 1.4,
        },
        navigation: {
            alignSelf: 'center',
        },
        navGroups: {
            '&:active, &:focus': {
                outline: 'none',
            },
        },
        noCursor: {
            cursor: 'inherit',
        },
        bottomSheet: {
            width: '100%',
            maxWidth: theme.breakpoints.values.sm,
            margin: 'auto',
            userSelect: 'none',
        },
    });
});
var UserMenuRender = function (props, ref) {
    var theme = core_1.useTheme();
    var avatar = props.avatar, classes = props.classes, menu = props.menu, menuGroups = props.menuGroups, MenuProps = props.MenuProps, menuSubtitle = props.menuSubtitle, menuTitle = props.menuTitle, _a = props.useBottomSheetAt, useBottomSheetAt = _a === void 0 ? theme.breakpoints.values.sm : _a, BottomSheetProps = props.BottomSheetProps, onClose = props.onClose, onOpen = props.onOpen, otherDivProps = __rest(props, ["avatar", "classes", "menu", "menuGroups", "MenuProps", "menuSubtitle", "menuTitle", "useBottomSheetAt", "BottomSheetProps", "onClose", "onOpen"]);
    var defaultClasses = useStyles(theme);
    var _b = react_1.useState(null), anchorEl = _b[0], setAnchorEl = _b[1];
    var closeMenu = react_1.useCallback(function () {
        onClose();
        setAnchorEl(null);
    }, [onClose]);
    // Add closeMenu function to each item that has an onClick function.
    react_1.useEffect(function () {
        for (var _i = 0, menuGroups_1 = menuGroups; _i < menuGroups_1.length; _i++) {
            var group = menuGroups_1[_i];
            var _loop_1 = function (item) {
                var onClick = item.onClick;
                if (onClick) {
                    item.onClick = function (e) {
                        onClick(e);
                        closeMenu();
                    };
                }
            };
            for (var _a = 0, _b = group.items; _a < _b.length; _a++) {
                var item = _b[_a];
                _loop_1(item);
            }
        }
    }, [menuGroups]);
    var canDisplayMenu = react_1.useCallback(function () { return Boolean(menu || menuGroups.length > 0); }, [menu, menuGroups]);
    var openMenu = react_1.useCallback(function (event) {
        onOpen();
        setAnchorEl(event.currentTarget);
    }, [onOpen]);
    /* Clones Avatar that user provides UserMenu & appends a click event so it opens the menu. */
    var formatAvatar = react_1.useCallback(function (preserveOnClick) {
        var _a;
        /* If user passed in onClick function as a prop to Avatar, keep it. */
        var onClickFn = function (event) {
            openMenu(event);
            if (avatar.props && avatar.props.onClick) {
                avatar.props.onClick(event);
            }
        };
        var aProps = avatar.props || {};
        return react_1.default.cloneElement(avatar, __assign(__assign({}, aProps), { onClick: preserveOnClick ? onClickFn : undefined, classes: __assign(__assign({}, aProps.classes), { root: clsx_1.default(defaultClasses.avatarRoot, preserveOnClick ? '' : defaultClasses.noCursor, (_a = aProps === null || aProps === void 0 ? void 0 : aProps.classes) === null || _a === void 0 ? void 0 : _a.root) }) }));
    }, [avatar, onOpen, defaultClasses, classes]);
    /* DrawerHeader needs wrapped with key div to avoid ref warning on FC. */
    var printHeader = react_1.useCallback(function () {
        if (menuTitle) {
            var nonClickableAvatar = formatAvatar(false);
            return (react_1.default.createElement("div", { className: defaultClasses.header, key: 'header' },
                react_1.default.createElement(Drawer_1.DrawerHeader, { icon: nonClickableAvatar, title: menuTitle, subtitle: menuSubtitle, fontColor: 'inherit', backgroundColor: 'inherit', divider: true, classes: {
                        root: defaultClasses.headerRoot,
                        title: defaultClasses.menuTitle,
                        navigation: defaultClasses.navigation,
                    } })));
        }
    }, [menuTitle, menuSubtitle, avatar]);
    /* DrawerNavGroup needs wrapped with key div to avoid ref warning on FC. */
    var printMenuItems = react_1.useCallback(function () {
        return menuGroups.map(function (group, index) { return (react_1.default.createElement("div", { className: defaultClasses.navGroups, key: index },
            react_1.default.createElement(Drawer_1.DrawerNavGroup, { divider: false, itemIconColor: group.iconColor, itemFontColor: group.fontColor, title: group.title, items: group.items.map(function (item, itemIndex) {
                    return Object.assign({ itemID: itemIndex.toString() }, item, {
                        InfoListItemProps: Object.assign({
                            iconColor: item.itemIconColor || group.iconColor || theme.palette.text.secondary,
                        }, item.InfoListItemProps),
                    });
                }) }))); });
    }, [menuGroups, defaultClasses]);
    var printMenu = react_1.useCallback(function () { return [printHeader()].concat(printMenuItems()); }, [
        printHeader,
        printMenuItems,
    ]);
    var formatMenu = react_1.useCallback(function () {
        var showBottomSheet = core_1.useMediaQuery("(max-width:" + useBottomSheetAt + "px)");
        /* If the user provides a menu, provide default props. */
        if (menu) {
            return react_1.default.cloneElement(menu, __assign({ anchorEl: anchorEl, open: Boolean(anchorEl), onClose: closeMenu }, menu.props));
        }
        return showBottomSheet ? (react_1.default.createElement(core_1.Drawer, __assign({ "data-cy": "bottom-sheet", anchor: 'bottom', transitionDuration: theme.transitions.duration.short, open: Boolean(anchorEl), onClose: closeMenu, classes: { paper: clsx_1.default(defaultClasses.bottomSheet, classes.bottomSheet) } }, BottomSheetProps), printMenu())) : (react_1.default.createElement(core_1.Menu, __assign({ open: Boolean(anchorEl), anchorEl: anchorEl, onClose: closeMenu, getContentAnchorEl: null }, MenuProps, { MenuListProps: { style: { padding: 0 } } }), printMenu()));
    }, [menu, anchorEl, closeMenu, MenuProps, printMenu, useBottomSheetAt, BottomSheetProps]);
    return (react_1.default.createElement("div", __assign({ ref: ref, className: clsx_1.default(defaultClasses.root, classes.root) }, otherDivProps),
        formatAvatar(true),
        canDisplayMenu() && formatMenu()));
};
/**
 * [UserMenu](https://pxblue-components.github.io/react/?path=/info/components-user-menu--get-read-me-story) component
 *
 * The `<UserMenu>` is an Avatar that opens a Menu when clicked. It is typically used in the top-right corner of an application and indicates who is logged in. By default, the Menu will responsively transition to a bottom sheet for mobile views (if passing in a custom menu, you will be responsible for handling any responsiveness on your content). Setting the `useBottomSheetAt` prop to zero will disable the responsiveness.
 */
exports.UserMenu = react_1.default.forwardRef(UserMenuRender);
exports.UserMenu.displayName = 'UserMenu';
exports.UserMenu.propTypes = {
    avatar: prop_types_1.default.element.isRequired,
    classes: prop_types_1.default.shape({
        root: prop_types_1.default.string,
        bottomSheet: prop_types_1.default.string,
    }),
    menu: prop_types_1.default.element,
    menuTitle: prop_types_1.default.string,
    menuSubtitle: prop_types_1.default.string,
    // @ts-ignore
    menuGroups: prop_types_1.default.arrayOf(prop_types_1.default.shape({
        title: prop_types_1.default.string,
        fontColor: prop_types_1.default.string,
        iconColor: prop_types_1.default.string,
        items: prop_types_1.default.arrayOf(prop_types_1.default.shape({
            icon: prop_types_1.default.element,
            onClick: prop_types_1.default.func,
            statusColor: prop_types_1.default.string,
            subtitle: prop_types_1.default.string,
            title: prop_types_1.default.string,
            divider: prop_types_1.default.bool,
        })),
    })),
    MenuProps: prop_types_1.default.object,
    useBottomSheetAt: prop_types_1.default.number,
    onClose: prop_types_1.default.func,
    onOpen: prop_types_1.default.func,
};
exports.UserMenu.defaultProps = {
    classes: {},
    menuGroups: [],
    MenuProps: {},
    onClose: function () { },
    onOpen: function () { },
};
